<template>
  <scroll-right-frame>
    <div class="pay-stats-container">
      <!-- 筛选控制区 -->
      <el-card class="filter-card" shadow="never">
        <div class="filter-panel">
          <!-- 第一行：筛选条件 -->
          <el-row :gutter="20" class="filter-row">
            <el-col :span="7">
              <div class="filter-item">
                <label class="filter-label">日期范围：</label>
                <el-date-picker
                  v-model="filters.dateRange"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="onDateRangeChange">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="filter-item">
                <label class="filter-label">产品线：</label>
                <el-select
                  v-model="filters.productLineIds"
                  multiple
                  placeholder="请选择产品线"
                  clearable
                  collapse-tags
                  @change="onFilterChange">
                  <el-option
                    v-for="item in filterOptions.productLines"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="filter-item">
                <label class="filter-label">支付第三方：</label>
                <el-select
                  v-model="filters.payThirds"
                  multiple
                  placeholder="请选择支付第三方"
                  clearable
                  collapse-tags
                  @change="onFilterChange">
                  <el-option
                    v-for="item in filterOptions.payThirds"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="filter-item">
                <label class="filter-label">支付渠道：</label>
                <el-select
                  v-model="filters.channels"
                  multiple
                  placeholder="请选择支付渠道"
                  clearable
                  collapse-tags
                  @change="onFilterChange">
                  <el-option
                    v-for="item in filterOptions.channels"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <!-- 第二行：操作按钮 -->
          <el-row :gutter="20" class="button-row">
            <el-col :span="24" class="filter-buttons">
              <el-button type="primary" icon="el-icon-search" @click="loadChartsData">查询</el-button>
              <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
              <el-button
                type="success"
                icon="el-icon-refresh-right"
                :loading="loading"
                @click="refreshData">
                刷新数据
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!-- 统计卡片区 -->
      <el-row :gutter="20" class="stats-cards">
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon total-icon">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">{{ formatNumber(overview.successOrders) }}</div>
                <div class="stats-label">
                  成功订单数
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      统计时间范围内支付成功的订单总数
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon fee-icon">
                <i class="el-icon-coin"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">¥{{ formatMoney(overview.totalPayAmount) }}</div>
                <div class="stats-label">
                  支付总金额
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      统计时间范围内成功支付的订单总金额
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon refund-icon">
                <i class="el-icon-sold-out"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">¥{{ formatMoney(overview.totalRefundAmount) }}</div>
                <div class="stats-label">
                  退款总金额
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      统计时间范围内成功退款的订单总金额
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="stats-card" shadow="hover">
            <div class="stats-item">
              <div class="stats-icon net-icon">
                <i class="el-icon-money"></i>
              </div>
              <div class="stats-content">
                <div class="stats-value">¥{{ formatMoney(overview.netAmount) }}</div>
                <div class="stats-label">
                  净收入
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="max-width: 250px;">
                      支付总金额 - 退款总金额
                    </div>
                    <i class="el-icon-question stats-help-icon"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 图表区域 - 饼图行 -->
      <el-row :gutter="20" class="charts-row">
        <el-col :span="12">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>支付第三方分布</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示不同支付第三方（支付宝、微信、银行等）的使用占比
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <pay-third-pie-chart :data="payThirdStats" :loading="loading" />
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>支付渠道分布</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示不同支付渠道（PC、H5、APP等）的使用占比
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <channel-pie-chart :data="channelStats" :loading="loading" />
          </el-card>
        </el-col>
      </el-row>

      <!-- Top10客户排行 - 独立一行 -->
      <el-row :gutter="20" class="charts-row">
        <el-col :span="24">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>Top10 客户排行</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  按支付金额排序，展示支付金额最多的前10个客户
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <top-customers-chart :data="topCustomers" :loading="loading" />
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="charts-row">
        <el-col :span="24">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>支付趋势图</span>
              <div class="chart-tools">
                <el-radio-group v-model="trendType" size="mini" @change="onTrendTypeChange">
                  <el-radio-button label="amount">支付金额</el-radio-button>
                  <el-radio-button label="times">订单数量</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <trend-line-chart
              :data="dailyTrend"
              :type="trendType"
              :loading="loading" />
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="charts-row">
        <el-col :span="24">
          <el-card class="chart-card" shadow="never">
            <div slot="header" class="chart-header">
              <span>产品线分布</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示各产品线的支付金额和订单数量分布
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <product-line-chart :data="productLineStats" :loading="loading" />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </scroll-right-frame>
</template>

<script>
import util from '../../../../libs/util'
import ScrollRightFrame from '../../../../components/scroll-right-frame.vue'
import PayThirdPieChart from './components/pay-third-pie-chart.vue'
import ChannelPieChart from './components/channel-pie-chart.vue'
import TopCustomersChart from './components/top-customers-chart.vue'
import TrendLineChart from './components/trend-line-chart.vue'
import ProductLineChart from './components/product-line-chart.vue'

export default {
  name: 'PayStats',
  components: {
    ScrollRightFrame,
    PayThirdPieChart,
    ChannelPieChart,
    TopCustomersChart,
    TrendLineChart,
    ProductLineChart
  },
  data() {
    return {
      loading: false,
      trendType: 'amount',

      // 筛选条件
      filters: {
        dateRange: [],
        productLineIds: [],
        payThirds: [],
        channels: []
      },

      // 筛选选项
      filterOptions: {
        productLines: [],
        payThirds: [],
        channels: []
      },

      // 日期选择器配置
      pickerOptions: {
        // 禁止选择2021年之前的日期
        disabledDate(time) {
          return time.getTime() < new Date('2021-01-01').getTime()
        },
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },

      // 图表数据
      overview: {
        totalOrders: 0,
        successOrders: 0,
        totalPayAmount: 0,
        totalRefundAmount: 0,
        netAmount: 0,
        activeCustomers: 0
      },
      payThirdStats: [],
      channelStats: [],
      topCustomers: [],
      dailyTrend: [],
      productLineStats: []
    }
  },

  created() {
    this.initFilters()
    this.loadFilterOptions()
    this.loadChartsData()
  },

  methods: {
    /**
     * 初始化筛选条件
     */
    initFilters() {
      // 默认选中本月
      const end = new Date()
      const start = new Date()
      start.setDate(1)

      this.filters.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ]
    },

    /**
     * 加载筛选选项
     */
    async loadFilterOptions() {
      try {
        const response = await util.ajax.get('/entity/stats/pay/filter-options')
        if (response.data.meta.errCode === 0) {
          this.filterOptions = response.data.data
        }
      } catch (error) {
        this.$message.error('加载筛选选项失败: ' + error.message)
      }
    },

    /**
     * 加载图表数据
     */
    async loadChartsData() {
      if (this.loading) return

      this.loading = true
      try {
        const params = {
          startDate: this.filters.dateRange[0],
          endDate: this.filters.dateRange[1],
          productLineIds: this.filters.productLineIds,
          payThirds: this.filters.payThirds,
          channels: this.filters.channels
        }

        const response = await util.ajax.post('/entity/stats/pay/charts', params)
        if (response.data.meta.errCode === 0) {
          const data = response.data.data
          console.log('=== 支付统计数据 ===', data)

          this.overview = data.overview || {}
          this.payThirdStats = data.payThirdStats || []
          this.channelStats = data.channelStats || []
          this.topCustomers = data.topCustomers || []
          this.dailyTrend = data.dailyTrend || []
          this.productLineStats = data.productLineStats || []
        } else {
          this.$message.error('加载数据失败: ' + response.data.meta.errMsg)
        }
      } catch (error) {
        this.$message.error('加载数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    /**
     * 刷新数据
     */
    refreshData() {
      this.loadChartsData()
    },

    /**
     * 重置筛选条件
     */
    resetFilters() {
      this.initFilters()
      this.filters.productLineIds = []
      this.filters.payThirds = []
      this.filters.channels = []
      this.loadChartsData()
    },

    /**
     * 日期范围变化
     */
    onDateRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.loadChartsData()
      }
    },

    /**
     * 筛选条件变化
     */
    onFilterChange() {
      this.loadChartsData()
    },

    /**
     * 趋势图类型变化
     */
    onTrendTypeChange() {
      // 趋势图组件会自动响应type变化
    },

    /**
     * 格式化数字
     */
    formatNumber(num) {
      if (!num) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    /**
     * 格式化金额
     */
    formatMoney(amount) {
      if (!amount) return '0.00'
      return Number(amount).toFixed(2)
    },

    /**
     * 格式化日期
     */
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
.pay-stats-container {
  padding: 0 10px 0 0;
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.el-col {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

/* 筛选卡片 */
.filter-card {
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
}

.filter-card /deep/ .el-card__body {
  padding: 24px;
}

.filter-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.filter-label {
  flex-shrink: 0;
  width: 90px;
  font-weight: 600;
  text-align: right;
  padding-right: 12px;
  color: #303133;
}

.filter-item .el-select,
.filter-item .el-date-picker {
  flex: 1;
}

.button-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.filter-buttons .el-button {
  border-radius: 8px;
}

/* 统计卡片 */
.stats-cards {
  margin-bottom: 24px;
}

.stats-card {
  border-radius: 16px;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  max-width: 100%;
  box-sizing: border-box;
}

.stats-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.12);
}

.stats-card /deep/ .el-card__body {
  padding: 24px;
}

.stats-item {
  display: flex;
  align-items: center;
}

.stats-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 28px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.total-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.fee-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.refund-icon {
  background: linear-gradient(135deg, #fa7c91 0%, #f76b1c 100%);
}

.net-icon {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.stats-content {
  flex: 1;
}

.stats-value {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 8px;
}

.stats-label {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.stats-help-icon {
  font-size: 14px;
  color: #c0c4cc;
  cursor: help;
  transition: all 0.3s ease;
}

.stats-help-icon:hover {
  color: #667eea;
  transform: scale(1.15);
}

/* 图表卡片 */
.charts-row {
  margin-bottom: 24px;
}

.chart-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  max-width: 100%;
  box-sizing: border-box;
}

.chart-card /deep/ .el-card__header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 2px solid #e4e7ed;
  padding: 20px 24px;
}

.chart-card /deep/ .el-card__body {
  padding: 20px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.chart-help-icon {
  font-size: 16px;
  color: #909399;
  cursor: help;
  transition: all 0.3s ease;
  margin-left: 8px;
}

.chart-help-icon:hover {
  color: #667eea;
  transform: scale(1.2);
}

.chart-tools {
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>




// WEBPACK FOOTER //
// src/custom/components/stats/pay-stats/pay-stats.vue